import { render } from "./langSwitcher.vue?vue&type=template&id=79ef0a16"
import script from "./langSwitcher.vue?vue&type=script&lang=js"
export * from "./langSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__